import { CursorPaginatedApiResponse } from '../../../types/responses/cursor-paginated.response';
import { client } from './client';
import { PointStyleApiModel } from '../../../types/models/point-style.model';
import { SearchPointStylesApiRequest } from '../../../types/requests/point-styles/search-point-styles.request';
import { CreatePointStyleApiRequest } from '../../../types/requests/point-styles/create-point-style.request';
import { UpdatePointStyleApiRequest } from '../../../types/requests/point-styles/update-point-style.request';
import { GetPointStyleApiRequest } from '../../../types/requests/point-styles/get-point-style.request';
import { DeletePointStyleApiRequest } from '../../../types/requests/point-styles/delete-point-style.request';
import { AddTemplateToPointStyleApiRequest } from '../../../types/requests/point-styles/add-template-to-point-style.request';
import { RemoveTemplateFromPointStyleApiRequest } from '../../../types/requests/point-styles/remove-template-from-point-style.request';

export const createPointStyle = (params: CreatePointStyleApiRequest) =>
  client.post<PointStyleApiModel>('/point-styles', params);

export const updatePointStyle = ({ pointStyleId, ...params }: UpdatePointStyleApiRequest) =>
  client.patch<PointStyleApiModel>(`/point-styles/${pointStyleId}`, params);

export const getPointStyle = <T extends PointStyleApiModel>({ pointStyleId, ...params }: GetPointStyleApiRequest) =>
  client.get<T>(`/point-styles/${pointStyleId}`, { params });

export const searchPointStyles = <T extends PointStyleApiModel>(params: SearchPointStylesApiRequest) =>
  client.get<CursorPaginatedApiResponse<T>>(`/point-styles`, { params });

export const addTemplateToPointStyle = ({ pointStyleId, templateId }: AddTemplateToPointStyleApiRequest) =>
  client.post<void>(`/point-styles/${pointStyleId}/templates/${templateId}`);

export const removeTemplateFromPointStyle = ({ pointStyleId, templateId }: RemoveTemplateFromPointStyleApiRequest) =>
  client.delete<void>(`/point-styles/${pointStyleId}/templates/${templateId}`);

export const deletePointStyle = ({ pointStyleId }: DeletePointStyleApiRequest) =>
  client.delete<void>(`/point-styles/${pointStyleId}`);
